import { getGlobalObject } from '@datadog/browser-core';
export function isProfilingSupported() {
  var globalThis = getGlobalObject(); // This API might be unavailable in some browsers

  var globalThisProfiler = globalThis.Profiler;
  return globalThisProfiler !== undefined;
}